var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCompressedAirLeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49999 6.6665H8.33332C8.82778 6.6665 9.31113 6.51988 9.72225 6.24518C10.1334 5.97048 10.4538 5.58003 10.643 5.12321C10.8322 4.6664 10.8817 4.16373 10.7853 3.67878C10.6888 3.19383 10.4507 2.74837 10.1011 2.39874C9.75146 2.04911 9.306 1.811 8.82105 1.71454C8.3361 1.61808 7.83343 1.66759 7.37661 1.85681C6.9198 2.04603 6.52935 2.36646 6.25465 2.77758C5.97995 3.1887 5.83332 3.67205 5.83332 4.16651M3.33332 13.3332H12.5C12.9944 13.3332 13.4778 13.4798 13.8889 13.7545C14.3 14.0292 14.6205 14.4196 14.8097 14.8765C14.9989 15.3333 15.0484 15.8359 14.952 16.3209C14.8555 16.8059 14.6174 17.2513 14.2678 17.6009C13.9181 17.9506 13.4727 18.1887 12.9877 18.2851C12.5028 18.3816 12.0001 18.3321 11.5433 18.1429C11.0865 17.9537 10.696 17.6332 10.4213 17.2221C10.1466 16.811 9.99999 16.3276 9.99999 15.8332M1.66666 9.99984H15.8333C16.3278 9.99984 16.8111 9.85322 17.2222 9.57851C17.6334 9.30381 17.9538 8.91336 18.143 8.45655C18.3322 7.99973 18.3817 7.49707 18.2853 7.01211C18.1888 6.52716 17.9507 6.0817 17.6011 5.73207C17.2515 5.38244 16.806 5.14434 16.321 5.04788C15.8361 4.95141 15.3334 5.00092 14.8766 5.19014C14.4198 5.37936 14.0294 5.69979 13.7546 6.11091C13.4799 6.52204 13.3333 7.00538 13.3333 7.49984",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompressedAirLeak);
export default __webpack_public_path__ + "static/media/icon-compressed-air-leak.7ae625e8195753c5bafe56338e4beccf.svg";
export { ForwardRef as ReactComponent };